import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Edit2, Trash2, Loader2 } from "lucide-react";

interface PropertyActionsProps {
  onEdit: () => void;
  onDelete: () => void;
  isDeleting: boolean;
}

export const PropertyActions = ({ onEdit, onDelete, isDeleting }: PropertyActionsProps) => {
  return (
    <div className="flex justify-end gap-2 mt-auto pt-4">
      <Button
        variant="outline"
        size="sm"
        onClick={onEdit}
        disabled={isDeleting}
      >
        <Edit2 className="h-4 w-4 mr-2" />
        Edit
      </Button>
      <Button
        variant="destructive"
        size="sm"
        onClick={onDelete}
        disabled={isDeleting}
      >
        {isDeleting ? (
          <Loader2 className="h-4 w-4 animate-spin mr-2" />
        ) : (
          <Trash2 className="h-4 w-4 mr-2" />
        )}
        Delete
      </Button>
    </div>
  );
};